import { PageNotFoundEvent } from '@/services/analytics/events';
import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { CountryCode } from '@/store/ui';
import { LandingPageLoadEvent } from '@/services/analytics/events';
import { getCountryCodeByTopLevelDomain } from '@/helpers';

@Component({
  name: 'CmgPageNotFound',
  beforeRouteLeave(to, from, next) {
    // PageNotFound is used on all AEM content landing pages.
    // Refresh the page when leaving to NOO order pages like Checkout or My Preferences.
    // This prevents issues with navigating back in the browser.
    window.location.assign(to.fullPath);
    return;
    
  },
})
export default class CmgPageNotFound extends Vue {
  routeNotFound = false;
  passThroughRoute = '';

  get slateRepeatableUrl(): string {
    return this.$appStore.state.cms.images.backgrounds.slate.default;
  }

  get page404Url(): string {
    return this.$appStore.state.cms.images.pageNotFound.default;
  }

  get arrowIcon(): string {
    return this.$appStore.state.cms.images.icons.arrowRight.default;
  }

  get isGB(): boolean {
    return getCountryCodeByTopLevelDomain() === CountryCode.GB;
  }

  mounted() {
    // check to see if the current path is in our list of AEM paths that need to escape the router
    const path = window.location.pathname;
    const hash = window.location.hash;
    const hashString = hash.substring(1);
    const routedPaths = this.$services.config.getHeaderPages();
    const availableHashNames = ['common-questions', 'contact-support', 'make-a-suggestion'];
    const canonicalLink: HTMLLinkElement | null = document.querySelector('link[rel="canonical"]');
    
    if (routedPaths.includes(path) && !availableHashNames.includes(hashString)) {
      if (window.location.hostname !== 'localhost' && window.location.hostname !== '127.0.0.1') {
        const urlStem = `${window.location.protocol}//${window.location.hostname}`;
        window.location.href = `${urlStem}${path}${hash}`;
      } else {
        // redirect to int rather than an empty local page
        window.location.href = `https://www-int.chipotle.com${path}${hash}`;
      }
    }

    // On landing pages with PCEs, open the bag if a user just added a Make It Your Own PCE.
    if( this.$appStore.state.ui.shouldBagOpen ) {
      this.$services.bag.setBagVisibility(true);
      this.$services.ui.setLastSelectedElement('bag');
      Vue.nextTick(() => this.$services.ui.focusDiv('.fullModal'));
      this.$services.ui.setShouldBagOpen(false);
    }

    // Fire analytics event
    // Refactor: Remove template and rename to cmg-aem-landing-page
    let pageDetails;
    let cmpShow;
    if( window.adobeDataLayer && window.adobeDataLayer.length ) {
      cmpShow = window.adobeDataLayer.find((x: any) => x?.event === 'cmp:show' && x.page && x.eventInfo);
      pageDetails = cmpShow?.page[cmpShow.eventInfo.path.split('.')[1]];
    }
    if ( !pageDetails && window.document?.body?.dataset?.adobeJson ) {
      pageDetails = JSON.parse(window.document.body.dataset.adobeJson)[window.document?.body.id];
    }
    if( canonicalLink && canonicalLink.href?.indexOf('error-page/404') > -1) {
      this.$services.analytics.send(new PageNotFoundEvent());
    } else {
      this.$services.analytics.send(new LandingPageLoadEvent(pageDetails));
    }

  }
}
